import { ImpactHeroPage } from "@/components/impactReport/ImpactHeroPage";
import type { ImpactReportDocumentRenderOptions } from "@/interfaces/impactReportDocument";
import type { ImpactReportPage } from "@/interfaces/impactReportView";

interface ImpactHeroDocumentProps extends ImpactReportDocumentRenderOptions {
  pages: ImpactReportPage[];
}

/**
 * The scrolling document: the page model, mapped to pages, in the order the builder emitted
 * them. This component owns no editorial decision — what pages exist, in what order, and what
 * each says is settled in `buildImpactReportPageModel`, so the PDF stage can render the same
 * array at fixed geometry without re-deriving any of it.
 *
 * It takes the built model rather than the payload for that reason: deriving it here would put a
 * second consumer of the raw report behind this boundary, and the caller could no longer see
 * what the builder decided.
 *
 * The render options are forwarded UNREAD. They are the PDF serialiser's, they mean nothing at
 * this level, and inspecting them here would be this component deciding something about the
 * document — the one thing it is written not to do.
 */
export function ImpactHeroDocument({ pages, ...renderOptions }: ImpactHeroDocumentProps) {
  return (
    <div className="irv-doc">
      {pages.map((page) => (
        <ImpactHeroPage key={page.pageKey} page={page} {...renderOptions} />
      ))}
    </div>
  );
}
